import { queryOptions, useMutation, usePrefetchQuery, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { Org, orgQueryKeys, userQueryKeys } from '#api';

/** {@link featureFlagQueryOptions} fetches feature flags from the api. */
export const featureFlagQueryOptions = queryOptions({
  queryKey: orgQueryKeys.featureFlags(),
  queryFn: ({ signal }) => Org.getFeatureFlags({ signal }),
  // 10 minutes
  staleTime: 600000,
});

export function usePrefetchFeatureFlags() {
  usePrefetchQuery(featureFlagQueryOptions);
}

/**
 * {@link useSuspenseFeatureFlagsQuery} fetches feature flags from the api.
 */
export function useSuspenseFeatureFlagsQuery() {
  return useSuspenseQuery(featureFlagQueryOptions);
}

/** {@link deploymentFeatureFlagQueryOptions} fetches deployment-wide feature flags without authentication. */
export const deploymentFeatureFlagQueryOptions = queryOptions({
  queryKey: orgQueryKeys.deploymentFeatureFlags(),
  queryFn: ({ signal }) => Org.getDeploymentFeatureFlags({ signal }),
  staleTime: 600000,
});

/**
 * {@link useRenameOrgMutation} renames the current organization. The org's name comes from whoami,
 * so it settles once whoami has refetched.
 */
export function useRenameOrgMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: Org.renameOrg,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: userQueryKeys.anyCurrent() }),
  });
}
